import { Link } from "react-router-dom";
import Layout, { PageHeader } from "../../components/Layout";
import { CaretLeft } from "@phosphor-icons/react";

// Shared chrome for every /settings/* sub-page so the back-to-hub
// breadcrumb and PageHeader styling stay consistent.
export default function SettingsPageShell({ title, overline = "SETTINGS", description, children, testid }) {
  return (
    <Layout>
      <PageHeader overline={overline} title={title} />
      <div className="px-8 pt-4 pb-3 bg-white border-b border-[#E5E7EB]">
        <Link
          to="/settings"
          data-testid="settings-back"
          className="inline-flex items-center gap-1.5 text-[12px] font-semibold text-[#4B5563] hover:text-[#121216] transition-colors"
        >
          <CaretLeft size={12} weight="bold" />
          All settings
        </Link>
        {description && (
          <p className="mt-2 text-[12px] text-[#4B5563] leading-relaxed max-w-3xl">{description}</p>
        )}
      </div>
      <div data-testid={testid} className="bg-[#FAFAFA] min-h-screen">
        {children}
      </div>
    </Layout>
  );
}
